import { InputBoX, SearchData, TableHead } from "../../../../common/dataClass/Default"

class ProductSupplier{
  constructor() {
    this.id = ''
    /**名称 */
    this.name = ''
    /**星级 */
    this.star = ''
    /**地址 */
    this.province = ''
    this.city = ''
    this.county = ''
    this.location = ''
    /**联系人 */
    this.concatName = ''
    /**手机号 */
    this.phone = ''
    this.telPhone = ''
    this.qq = ''
    /**旺旺号 */
    this.aliNum = ''
    /**创建/修改时间 */
    this.time = ''
    /**备注信息 */
    this.remark = ''
  }
  /**后端返回的详情数据 */
  backendDetailDataParsing(){

  }
}

class ProductSupplierSearchData extends SearchData{
  constructor() {
    super()
    this.time = null
  }
}

class ProductSupplierInputBox extends InputBoX{
  constructor(type, name, data, obj = { isRequired: false }){
    super(type, name, data, obj)
    /**是否必填 */
    this.isRequired = obj.isRequired == undefined ? true : obj.isRequired
  }
}

class ProductSupplierTableHead extends TableHead{
  constructor(name, prop, width, obj) {
    super(name, prop, width, obj)
  }
}

class ProductSupplierInputBoxNewModule{
  static NEWTABLEHEAD(){
    let arr = [
      new ProductSupplierTableHead('产品供应商ID', 'id', '150'),
      new ProductSupplierTableHead('产品供应商名称', 'name', '150'),
      new ProductSupplierTableHead('产品供应商地址', 'detailLocation', '150'),
      new ProductSupplierTableHead('仓库数量及详情', 'type', '150'),
      new ProductSupplierTableHead('联系人', 'concatName', '150'),
      new ProductSupplierTableHead('手机号', 'phone', '150'),
      new ProductSupplierTableHead('座机', 'telPhone', '150'),
      new ProductSupplierTableHead('QQ', 'qq', '150'),
      new ProductSupplierTableHead('旺旺号', 'aliNum', '150'),
      new ProductSupplierTableHead('备注', 'remark', '150'),
      new ProductSupplierTableHead('创建日期', 'time', '150'),
      new ProductSupplierTableHead('操作', 'operate', '150'),
    ]
    return arr
  }
  static NEWSUPPLIERINPUTMODULE(){
    let obj = {
      name: new ProductSupplierInputBox('text', '产品供应商公司名称', 'name', { isRequired: true, pla: '请输入供应商名称(可用简称或代号录入)' }),
      star: new ProductSupplierInputBox('select', '产品供应商星级', 'star', { isRequired: true, pla: '' }),
      location: new ProductSupplierInputBox('location', '产品供应商公司地址', 'location', { isRequired: true, pla: '' }),
    }
    return obj
  }
  static NEWCONCATINPUTMODULE(){
    let obj = {
      concatName: new ProductSupplierInputBox('text', '联系人', 'concatName', { isRequired: true, pla: '请输入联系人' }),
      phone: new ProductSupplierInputBox('text', '手机号', 'phone', { isRequired: true, pla: '请输入手机号' }),
      telPhone: new ProductSupplierInputBox('text', '座机', 'telPhone', { isRequired: false, pla: '请输入座机号码' }),
      qq: new ProductSupplierInputBox('text', 'QQ', 'qq', { isRequired: false, pla: '请输入QQ号码' }),
      aliNum: new ProductSupplierInputBox('text', '旺旺号', 'aliNum', { isRequired: false, pla: '请输入旺旺号' }),
    }
    return obj
  }
  /**站外费用申请进度条 */
  static NEWPROGRESSARRAY(){
    let arr = [
      '选择商品所属的店铺及国家站点',
      '选择对应的某一商品',
      '选择费用类别,服务供应商及输入申请金额',
      '点击生成推广费用申请单'
    ]
    return arr
  }
}

export { ProductSupplier, ProductSupplierInputBoxNewModule, ProductSupplierSearchData }
